import {SODeleteIdentity} from '../../core/identity/so-delete-identity';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteIdentity extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteIdentity;
}